"use strict";
define(["wtm_libs"], function(e) {
    function t() {
        e.debug_mode && console.log("> Start header function;"), document.getElementsByClassName(e.header.get__header_class)[0] && (r.forEach(function(t) {
            for (var s = 0; s < t.classList.length; s++)
                if (a.test(t.classList.item(s))) return void d.push(t.classList.item(s) + e.header.set__header_modifier)
        }), o = $(window).scrollTop(), s(o), window.addEventListener("scroll", function(e) {
            o = $(window).scrollTop(), n || window.requestAnimationFrame(function() {
                s(o), n = !1
            }), n = !0
        })), e.debug_mode && console.log(">>> Header loaded;")
    }

    function s(t) {
        if (o > e.header.set__trigger) {
            if (document.getElementsByClassName(d[0])[0]) return;
            for (var s = 0; s < r.length; s++) r[s].classList.add(d[s])
        } else
            for (var n = 0; n < r.length; n++) r[n].classList.remove(d[n])
    }
    var o = void 0,
        n = !1,
        r = Array.prototype.slice.call(document.querySelectorAll("[class*=" + e.header.get__header_class + "]")),
        a = new RegExp(e.header.get__header_class),
        d = [];
    "complete" !== document.readyState ? document.addEventListener("DOMContentLoaded", t()) : t()
});

